import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  connected: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& .MuiTypography-root': {
      fontSize: theme.spacing(1.5),
      textTransform: 'uppercase',
    },
  },

  notConnected: {},

  doneIcon: {
    marginRight: theme.spacing(1),
  },
}));
